import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { FormProps } from '~/common/types/form'

type PostUrl = 'applicant' | 'repost' | 'register'

export const formApi = createApi({
  reducerPath: 'formApi',
  baseQuery: fetchBaseQuery({ baseUrl: process.env.API_URL }),
  endpoints: (builder) => ({
    post: builder.mutation<FormProps, FormProps & { postUrl: PostUrl }>({
      query: ({ postUrl, ...body }) => ({
        url: postUrl,
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { usePostMutation } = formApi
